<script setup lang="ts">
// Contas Bancárias do Minha Conta V2 (ENG-362). Reaproveita o componente
// antigo (components/user/account/BankAccounts/PayerAccounts.vue), que já
// lista/adiciona/edita/remove conta bancária (agência+conta) — só embutido
// no card padrão do painel V2 e com variant="v2" pro visual escuro.
// Só faz sentido pra BRL (agência/conta é formato do sistema bancário
// brasileiro; MXN usa CLABE, tratado por outro componente/tela, ainda sem
// equivalente aqui) — mesmo gate do site antigo (pages/user/account.vue).
const { userCurrency } = useUserData();
</script>

<template>
  <div
    class="border-solid flex flex-col rounded-[16px] border border-v2-default/40 p-[16px]"
  >
    <UserAccountBankAccountsPayerAccounts
      v-if="userCurrency === 'BRL'"
      variant="v2"
    />
  </div>
</template>
